import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=a78a3b46&lang=pug"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=a78a3b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports